import styled from 'styled-components';
import { colors } from '../../base/styled/variables.styled';
export const Container = styled.div `
  width: 100%;
  height: 100%;
  background-color: ${colors.neutral000};
  min-height: 100vh;
  display: flex;
  flex-direction: column;
`;
export const MainContent = styled.div `
  flex: 1;
`;
//# sourceMappingURL=MainLayout.style.js.map